<template>
  <div class="card border border-secondary">
    <div class="card-body">
      <h1 class="text-center">
        Tahsilat Rapor Bilgileri
      </h1><hr>

      <div class="container">
        <div class="row">
          <div class="col">
            <div>

              <b-form-datepicker
                id="example-datepicker"
                v-model="value"
                class="mb-1"
              />
            </div>

          </div>
          <div class="col">
            <div>
              <b-form-select
                v-model="selected"
                :options="options"
              />

            </div><br>
          </div>
          <div class="col">
            <div>
              <b-form-select
                v-model="selected1"
                :options="options1"
              />

            </div><br>
          </div>
        </div>
      </div>
      <div>
        <b-table
          :items="items"
          :fields="fields"
          striped
          responsive
        >
          <template #cell(islem)="row">
            <b-form-checkbox
              v-model="row.detailsShowing"
              plain
              class="vs-checkbox-icon"
              @change="row.toggleDetails"
            >
              <span class="vs-checkbox">
                <span class="vs-checkbox--check">
                  <i class="vs-icon feather icon-check" />
                </span>
              </span>
              <span class="vs-label">{{ row.detailsShowing ? 'Gizle' : 'Göster' }}</span>
            </b-form-checkbox>
          </template>

          <template #row-details="row">
            <b-card>
              <h6 class="text-center alert alert-danger">
                Firma Ödeme Durumunu Belirtmeniz Gerekmektedir.
              </h6>
              <div class="demo-inline-spacing d-flex justify-content-center">
                <div class="demo-inline-spacing">
                  <b-form-radio
                    v-model="Selected"
                    name="some-radio9"
                    value="e"
                    class="custom-control-danger"
                  >
                    Ödenmedi
                  </b-form-radio>
                  <b-form-radio
                    v-model="Selected"
                    name="some-radio9"
                    value="ff"
                    class="custom-control-success"
                  >
                    Ödendi
                  </b-form-radio>
                </div>
                <div>
                  <!-- Styled -->
                  <b-form-file
                    v-model="file"
                    size="sm"
                    :state="Boolean(file)"
                    placeholder="Faturayı Yükleyin"
                    drop-placeholder="Dosya Seçin..."
                    no-drop
                    multiple
                  />
                </div>

                <b-button
                  v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                  size="sm"
                  variant="outline-primary"
                >
                  <feather-icon icon="Edit2Icon" />
                  Düzenle
                </b-button>
                <b-button
                  v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                  size="sm"
                  variant="outline-info"
                >
                  <feather-icon icon="PrinterIcon" />
                  Verileri Yazdır
                </b-button>
                <b-button
                  v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                  size="sm"
                  variant="outline-success"
                >
                  <feather-icon icon="CheckIcon" />
                  Kaydet
                </b-button>

                <b-button
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  size="sm"
                  variant="outline-danger"
                  @click="row.toggleDetails"
                >
                  <feather-icon icon="XIcon" />
                  Kapat
                </b-button>
              </div>

            </b-card>
          </template>

          <template #cell(avatar)="data">
            <b-avatar :src="data.value" />
          </template>

          <template #cell(status)="data">
            <b-badge :variant="status[1][data.value]">
              {{ status[0][data.value] }}
            </b-badge>
          </template>
        </b-table>
        <div class="index">
          <h5>
            Toplam Tutar (₺)
          </h5>

          <b-form-group

            label="Basic Input"
            label-for="basicInput"
          >
            <b-form-input
              id="basicInput"
              placeholder="0"
              disabled
            />
          </b-form-group>
        </div>
        <div class="demo-inline-spacing d-flex justify-content-left">

          <b-button
            v-ripple.400="'rgba(255, 159, 67, 0.15)'"
            variant="outline-dark"
          >
            <feather-icon
              icon="CornerLeftDownIcon"
            />
            Excele Aktar
          </b-button>
          <b-button
            v-ripple.400="'rgba(0, 207, 232, 0.15)'"
            variant="outline-dark"
          >
            <feather-icon
              icon="FileTextIcon"
            />
            PDF İndir
          </b-button>
          <b-button
            v-ripple.400="'rgba(30, 30, 30, 0.15)'"
            variant="outline-dark"
          >
            <feather-icon
              icon="FilterIcon"
            />
            Filtrele
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  BTable, BFormCheckbox, BButton, BCard, BBadge, BFormSelect, BFormDatepicker, BFormInput, BFormFile, BFormRadio,
} from 'bootstrap-vue'

export default {
  components: {
    BTable,
    BButton,
    BFormCheckbox,
    BFormRadio,
    BCard,
    BFormInput,
    BFormFile,
    BBadge,

    BFormSelect,
    BFormDatepicker,
  },
  data() {
    return {
      selected: null,
      options: [
        { value: null, text: 'Fatura Dönemi Seçiniz' },
        { value: 'a', text: 'Ocak' },
        { value: 'b', text: 'Şubat' },
        { value: 'c', text: 'Mart' },
        { value: 'd', text: 'Nisan' },
        { value: 'd', text: 'Mayıs' },
        { value: 'd', text: 'Haziran' },
        { value: 'd', text: 'Temmuz' },
        { value: 'd', text: 'Ağustos' },
        { value: 'd', text: 'Eylül' },
        { value: 'd', text: 'Ekim' },
        { value: 'd', text: 'Kasım' },
        { value: 'd', text: 'Aralık' },
      ],
      selected1: null,
      options1: [

        { value: null, text: 'Firma Adını Seçiniz' },
        { value: '1', text: 'A Firması' },
        { value: '2', text: 'B Firması' },
      ],
      value1: null,
      options3: [
        { text: 'Ödenmedi', value: 'first' },
        { text: 'Ödendi', value: 'second' },

      ],
      computed: {
        state() {
          return Boolean(this.value)
        },
      },
      fields: ['islem', 'id', 'firma_adı', 'sektör', 'Trafo_no', 'ilk_okuma_tarihi', 'son_okuma_tarihi', 'Tahsilat_Tutarı', 'Nace_Kodu', { key: 'status', label: 'Ödeme Durumu' }],
      items: [
        {
          id: 1,
          // eslint-disable-next-line global-require
          avatar: require('@/assets/images/avatars/10-small.png'),
          firma_adı: 'A Firması',
          sektör: 'Demir-Çelik',
          Trafo_no: 'TR19',
          ilk_okuma_tarihi: '25/06/2022 09.35',
          son_okuma_tarihi: '25/06/2022 09.56',

          Tahsilat_Tutarı: '0 ₺',
          Nace_Kodu: '4125',
          status: 5,
        },

      ],
      status: [{
        1: 'Ödeme Bekleniyor ', 2: 'Ödendi', 3: 'Ödenmedi', 4: 'Resigned', 5: 'Ödeme Bilgisi Alınamadı',
      },
      {
        1: 'light-primary', 2: 'light-success', 3: 'light-danger', 4: 'light-warning', 5: 'light-info',
      }],
    }
  },

}
</script>
<style>
.index{
  float: right;
}

</style>
